import { Accordion, Carousel, Modal } from "react-bootstrap";
import foto1 from "../../../assets/fotosTallas/frente.jpg";
import foto2 from "../../../assets/fotosTallas/espalda.jpg";
import foto3 from "../../../assets/fotosTallas/costado.jpg";
import foto4 from "../../../assets/fotosTallas/NIÑO FRENTE.jpg";
import foto5 from "../../../assets/fotosTallas/NIÑO ESPALDA.jpg";
import foto6 from "../../../assets/fotosTallas/NIÑO COSTADO.jpg";
import fichaNiño from "../../../assets/fotosTallas/Presentación1.jpg";
import fichaAdulto from "../../../assets/fotosTallas/FICHA.JPG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
export const ModalTablaTallas = ({
  showModalTallas,
  handleCloseModalTallas,
}) => {
  const imagesAdulto = [foto1, foto2, foto3];
  const imagesNiño = [foto4, foto5, foto6];
  return (
    <Modal
      className="text-center"
      show={showModalTallas}
      onHide={handleCloseModalTallas}
      size="lg"
      centered={true}
    >
      <Modal.Header>
        <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10  text-start">
          <Modal.Title style={{ fontSize: "1.2rem" }}>
            {"Tabla de tallas"}
          </Modal.Title>
        </div>
        <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 text-end">
          <FontAwesomeIcon
            icon={faXmark}
            size="xl"
            onClick={handleCloseModalTallas}
            className="icon-ficha"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Niños</Accordion.Header>
            <Accordion.Body>
              <div className="row">
                {" "}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-center pt-3 pb-3">
                  <img src={fichaNiño} className="img-fluid"></img>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-center pt-3 pb-3">
                  <Carousel
                    data-bs-theme="dark"
                    indicators={false}
                    controls={false}
                  >
                    {imagesNiño.map((image, index) => (
                      <Carousel.Item key={index} interval={2000}>
                        <img
                          className="d-block w-100"
                          src={image}
                          alt={`slide-ninos-${index}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Adulto</Accordion.Header>
            <Accordion.Body>
               <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-center pt-3 pb-3">
                <img src={fichaAdulto}  className="img-fluid"></img>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-center pt-3 pb-3">
                <Carousel
                  data-bs-theme="dark"
                  className="carousel-modal"
                  indicators={false}
                  controls={false}
                >
                  {imagesAdulto.map((image, index) => (
                    <Carousel.Item key={index} interval={2000}>
                      <img
                        className="d-block w-100"
                        src={image}
                        alt={`slide-adulto-${index}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>
    </Modal>
  );
};
